// import _get from "lodash/get";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import MapIcon from "@mui/icons-material/Map";
import AppsIcon from "@mui/icons-material/Apps";
import SettingsIcon from "@mui/icons-material/Settings";
import NavigatorLinks from "./NavigatorLinks";
import HistoryIcon from "@mui/icons-material/History";

import {
  isUnity,
  // isSmartelds,
  // isEldBooks,
  // isVulcansols,
  // isEldNN
} from "../configureStore";
import { LABELS } from "../language";

const ALL_LABELS = LABELS.navigation;
const appRoutes = [
  {
    id: "Dashboard",
    label: ALL_LABELS.dashboard,
    url: "/dashboard",
    children: [
      {
        id: "Accounts",
        label: ALL_LABELS.accounts,
        icon: <AppsIcon />,
        url: "/accounts",
        admin: true, // Admin only route
        superAdmin: true, // Admin only route
        partner: true, // Partner only route
        adminSupport: true,
      },
      
      {
        id: "Duty Status",
        label: ALL_LABELS.dutyStatus,
        icon: <AppsIcon />,
        url: "/status/diary/:driverId",
        driver: true,
      },
      {
        id: "Dvir",
        label: ALL_LABELS.dvir,
        icon: <AppsIcon />,
        url: "/dvir",
        driver: true,
      },
      {
        id: "Daily Logs",
        label: ALL_LABELS.dailyLogs,
        icon: <HistoryIcon />,
        active: true,
        url: "/status/view",
        manager: true,
      },
      {
        id: isUnity ? "Fleet manager" : "Settings",
        label: isUnity ? ALL_LABELS.fleetManager : ALL_LABELS.settings,
        icon: <SettingsIcon />,
        url: "/settings/user",
        manager: true,
      },
    
    ],
  },
];

const styles = (theme) => ({
  categoryHeader: {
    paddingTop: 10,
    paddingBottom: 10,
  },
  categoryHeaderPrimary: {
    color: theme.palette.common.white,
  },
  headerLogo: {
    width: 55,
    margin: "auto",
  },
  item: {
    paddingTop: 8,
    paddingBottom: 8,
    margin: "4px 0",
    fontSize: 14,
    fontWeight: 400,
    color: "#41536e",
    borderRadius: 4,
    "&:hover": {
      backgroundColor: "#f4f5f7",
    },
  },
  itemCategory: {
    backgroundColor: "#171F2A",
    boxShadow: "0 -1px 0 #404854 inset",
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 10,
    paddingRight: 10,
  },
  firebase: {
    fontSize: 24,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.common.white,
  },
  itemActionable: {
    "&:hover": {
      backgroundColor: "#009ddd26",
    },
  },
  itemActiveItem: {
    color: "#009ddd",
    backgroundColor: "#009ddd26",
    position: "relative",
  },
  itemPrimary: {
    color: "inherit",
    fontSize: theme.typography.fontSize,
    "&$textDense": {
      fontSize: theme.typography.fontSize,
    },
  },
  textDense: {},
  divider: {
    backgroundColor: "#dfe1e6",
    height: 2,
    marginTop: 0,
  },
});

class MainNavigator extends React.Component {
  render() {
    const { classes, onClose, show, setShow, ...other } = this.props;

    return (
      <Drawer
        anchor="left"
        variant="permanent"
        {...other}
        onClose={() => {
          onClose();
        }}
      >
        <List style={{ marginTop: 10 }} className="sidebar-list">
          <NavigatorLinks
            index={1}
            show={show}
            appRoutes={appRoutes}
            classes={classes}
            onClose={onClose}
          />
        </List>
        <Paper>
          <div className="slide-toggle">
            <div className="slide-togglebar "></div>
            <div className="toggle-line">
              <span className="css-xwsnrl"></span>
            </div>
            <div>
              <button
                type="button"
                className={`toggle-btn ${
                  show ? "toggle-btn-r1" : "toggle-btn-r2"
                }`}
                onClick={setShow}
              >
                <span className="css-pxzk9z">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    role="presentation"
                  >
                    <path
                      d="M10.294 9.698a.988.988 0 010-1.407 1.01 1.01 0 011.419 0l2.965 2.94a1.09 1.09 0 010 1.548l-2.955 2.93a1.01 1.01 0 01-1.42 0 .988.988 0 010-1.407l2.318-2.297-2.327-2.307z"
                      fill="currentColor"
                      fillRule="evenodd"
                    ></path>
                  </svg>
                </span>
                <div className="css-z8pkji"></div>
              </button>
            </div>
          </div>
        </Paper>
      </Drawer>
    );
  }
}

MainNavigator.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({});
export default withStyles(styles)(connect(mapStateToProps, {})(MainNavigator));
